import {
  Fragment, useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  CalendarOutlined,
  ToolOutlined,
  SafetyCertificateOutlined,
  DashboardOutlined,
  ArrowRightOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByKey: Record<string, JSX.Element> = {
  plan: <CalendarOutlined />,
  produce: <ToolOutlined />,
  qc: <SafetyCertificateOutlined />,
  oee: <DashboardOutlined />,
};

interface WorkflowFlowProps {
  className?: string;
  variant?: "default" | "compact";
}

const WorkflowFlow = ({ className = "", variant = "default" }: WorkflowFlowProps) => {
  const { t } = useTranslation("mes");
  const isCompact = variant === "compact";

  const steps = useMemo(() => {
    const raw = t("workflow.steps", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ key: string; label: string }>;
  }, [t]);

  return (
    <div
      className={[
        "dev-mes-workflow-grid",
        isCompact ? "dev-mes-workflow--compact" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="dev-mes-workflow-track">
        {steps.map((step, idx) => (
          <Fragment key={step.key}>
            {isCompact ? (
              <div className="dev-mes-step-item">
                <div className={`dev-mes-step-card dev-mes-step-card--${step.key}`}>
                  <div className="dev-mes-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                </div>
                <div className="dev-mes-step-title">{step.label}</div>
              </div>
            ) : (
              <div className={`dev-mes-step-card dev-mes-step-card--${step.key}`}>
                <div className="dev-mes-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                <div className="dev-mes-step-title">{step.label}</div>
              </div>
            )}
            {idx < steps.length - 1 && (
              <div className="dev-mes-step-connector" aria-hidden>
                <ArrowRightOutlined />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default WorkflowFlow;
